<template>
  <div 
    class="mt-4">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1 pt-1">
              <v-card
                flat
                color="#ffffff">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="22">
                        <v-img contain :src="data_menu.icon"></v-img>
                        <!-- <v-img
                          contain
                          alt="kominfoklaten"  
                          :src="require('@/assets/image/grip_menu.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="15"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img> -->
                      </v-avatar>
  
                      <div
                        class="fs-16 black--text ml-3"
                        style="font-weight: 600; padding-top: 1px;">
                        {{ $route.meta.title }}
                      </div>
                    </div>

                    <v-spacer />
                    <div class="d-flex align-center">
                      <v-autocomplete
                        v-on:change="fetch()"
            
                        solo
                        rounded
                        dense
                        single-line
            
                        hide-details
                        :color="set_color"
                        placeholder="Pilih Sekolah"
                        prepend-inner-icon="mdi-magnify"
                        :items="school"
                        item-text="name"
                        item-value="id"
                        v-if="(user.school_id === undefined || user.school_id === null) &&($store.state.school === null || $store.state.school === undefined || undefined === '')"
                        v-model="filter.school_id"
                        class="fs-11 little-placeholder ml-3"
                        style="border-radius: 6px; background: #fff !important; max-width: 400px">
                      </v-autocomplete>

                      <v-autocomplete
                        v-on:change="fetch()"
            
                        solo
                        rounded
                        dense
                        single-line
            
                        hide-details
                        :color="set_color"
                        placeholder="Pilih Tahun"
                        prepend-inner-icon="mdi-calendar"
                        :items="years"
                        item-text="text"
                        item-value="value"
                        v-model="filter.year"
                        class="fs-11 little-placeholder ml-3"
                        style="border-radius: 6px; background: #fff !important; max-width: 200px">
                      </v-autocomplete>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-card flat style="background-color: transparent;">
            <v-card-text class="py-2">
              <v-row>
                <v-col cols="4">
                  <v-card flat style="background-color: #fef6eb; border-radius: 6px;" height="90">
                    <v-card-text>
                      <div class="d-flex">
                        <div>
                          <v-avatar
                            tile
                            size="50">
                            <v-img contain :src="require('@/assets/icon/students.png')"></v-img>
                          </v-avatar>
                        </div>
                        <div class="ml-4" style="width: 100%;">
                          <div class="fs-13" style="font-weight: 700; color: #e2a03f;">
                            Total Siswa
                          </div>
                          <div class="d-flex align-center">
                            <div class="black--text fs-15" style="font-weight: 700;">
                              780.000
                            </div>
                            <div class="ml-auto fs-11">
                              <div class="black--text d-flex align-center">
                                <v-avatar
                                  tile
                                  size="15">
                                  <v-img contain :src="require('@/assets/icon/upward-arrow.png')"></v-img>
                                </v-avatar>
                                <div>
                                  <div class="fs-11">
                                    10%
                                  </div>
                                  <div class="fs-11">
                                    dari tahun lalu
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card flat style="background-color: #fff2f1; border-radius: 6px;" height="90">
                    <v-card-text>
                      <div class="d-flex">
                        <div>
                          <v-avatar
                            tile
                            size="50">
                            <v-img contain :src="require('@/assets/icon/family.png')"></v-img>
                          </v-avatar>
                        </div>
                        <div class="ml-4" style="width: 100%;">
                          <div class="fs-13" style="font-weight: 700; color: #e7515a;">
                            Total Wali Murid
                          </div>
                          <div class="d-flex align-center">
                            <div class="black--text fs-15" style="font-weight: 700;">
                              390.000
                            </div>
                            <div class="ml-auto fs-11">
                              <div class="black--text d-flex align-center">
                                <v-avatar
                                  tile
                                  size="15">
                                  <v-img contain :src="require('@/assets/icon/upward-arrow.png')"></v-img>
                                </v-avatar>
                                <div>
                                  <div class="fs-11">
                                    10%
                                  </div>
                                  <div class="fs-11">
                                    dari tahun lalu
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card flat style="background-color: #ecfdf3; border-radius: 6px;" height="90">
                    <v-card-text>
                      <div class="d-flex">
                        <div>
                          <v-avatar
                            tile
                            size="50">
                            <v-img contain :src="require('@/assets/icon/school-gedung.png')"></v-img>
                          </v-avatar>
                        </div>
                        <div class="ml-4" style="width: 100%;">
                          <div class="fs-13" style="font-weight: 700; color: #00ab55;">
                            Total Guru/Pegawai
                          </div>
                          <div class="d-flex align-center">
                            <div class="black--text fs-15" style="font-weight: 700;">
                              12.000
                            </div>
                            <div class="ml-auto fs-11">
                              <div class="black--text d-flex align-center">
                                <v-avatar
                                  tile
                                  size="15">
                                  <v-img contain :src="require('@/assets/icon/upward-arrow.png')"></v-img>
                                </v-avatar>
                                <div>
                                  <div class="fs-11">
                                    10%
                                  </div>
                                  <div class="fs-11">
                                    dari tahun lalu
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card flat class="mx-5 mb-2">
            <v-card-text>
              <div class="d-flex align-center mb-5">
                <div class="fs-16 grey--text text--darken-4" style="font-weight: 700;">
                  Grafik Kehadiran
                </div>
                <div class="ml-auto">
                  <v-autocomplete
                    solo
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Kehaditan"
                    prepend-inner-icon="mdi-calendar"
                    :items="['Siswa', 'Guru/Pegawai']"
                    v-model="filter.pengguna"
                    class="fs-11 little-placeholder ml-3"
                    style="border-radius: 6px; background: #fff !important; max-width: 200px">
                  </v-autocomplete>
                </div>
              </div>
              <div id="chart">
                <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
              </div>
            </v-card-text>
          </v-card>

          <v-row class="px-1">
            <v-col cols="12" md="6">
              <v-card-text class="py-0 pr-0">
                <v-card flat>
                  <v-card-text>
                    <div class="d-flex align-center mb-5">
                      <div class="fs-16 grey--text text--darken-4" style="font-weight: 700;">
                        Siswa Berdasarkan Jenis Kelamin
                      </div>
                      <div class="ml-auto">
                      </div>
                    </div>
                    <div class="d-flex justify-center">
                      <div id="chart">
                        <apexchart type="pie" width="400" :options="pieChart.chartOptions" :series="pieChart.series"></apexchart>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-col>

            <v-col cols="12" md="6">
              <v-card-text class="py-0 pl-0">
                <v-card flat>
                  <v-card-text>
                    <div class="d-flex align-center mb-5">
                      <div class="fs-16 grey--text text--darken-4" style="font-weight: 700;">
                        Siswa Berdasarkan Agama
                      </div>
                      <div class="ml-auto">
                      </div>
                    </div>
                    <div class="d-flex justify-center">
                      <div id="chart">
                        <apexchart type="pie" width="400" :options="pieChartAgama.chartOptions" :series="pieChartAgama.series"></apexchart>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-col>
          </v-row>

          <v-card flat class="mx-5 mb-2">
            <v-card-text>
              <div class="d-flex align-center mb-2">
                <div class="fs-16 grey--text text--darken-4" style="font-weight: 700;">
                  Kegiatan Belajar Mengajar
                </div>
                <div class="ml-auto d-flex align-center">
                  <v-text-field
                    solo
                    rounded
                    dense
                    type="date"
                    single-line
                    hide-details
                    :color="set_color"
                    placeholder="Pilih tanggal"
                    prepend-inner-icon="mdi-calendar"
                    class="fs-11 little-placeholder ml-3"
                    style="border-radius: 6px; background: #fff !important; max-width: 200px">
                  </v-text-field>
                  <v-autocomplete
                    solo
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    placeholder="Pilih Status"
                    prepend-inner-icon="mdi-calendar"
                    :items="['Hadir', 'Terlambat', 'Izin', 'Alpha']"
                    v-model="filter.status"
                    class="fs-11 little-placeholder ml-3"
                    style="border-radius: 6px; background: #fff !important; max-width: 200px">
                  </v-autocomplete>
                </div>
              </div>

              <div>
                <v-data-table
                    v-model="selected.row"
                    ref="table-grid"
                    class="table-grid"
                    :height="`calc(100vh - '248px'})`"
                    :show-select="checkbox"
                    :single-select="true"
                    :loading="process.load"
                    loading-text="Sedang memuat data . . ."
                    loader-height="5"
                    no-results-text="Belum ada data"
                    :options.sync="options"
                    :headers="configHeaders"
                    :items="list"
                    :items-per-page="100"
                    item-key="id"
                    @click:row="rowClick"
                    @toggle-select-all="handleToggleAll($event)"
                    @dblclick:row="doubleClick"
                    hide-default-footer
                    hide-default-header>
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="h in headers" :key="h" :style="`min-width: ${h.width === '' ? '' : h.width }; width: ${h.width === '' ? '' : h.width };background-color: #f3f4f6 !important; color: #000 !important;`" :class="`text-${h.align}`">
                            <span>{{h.text}}</span>
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template
                      v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                      v-slot:[`item.${header.value}`]="{ value, index, item }">
                      <div
                        v-bind:key="header.value">
                        <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                          {{ rowFormat(header.format, value) }} 
                        </div>
  
                        <div v-if="header.format === 'link'"
                          :style="value === 'Hadir' ? 'color: #28A745 !important;' : value === 'Terlambat' ? 'color: #007BFF !important;' : value === 'Izin' ? 'color: #FFC107 !important;' : 'color: #DC3545 !important;'">
                          <!-- <div :style="value === 'Hadir' ? 'border: 1px solid #28A745 !important;' : value === 'Terlambat' ? 'border: 1px solid #007BFF !important;' : value === 'Izin' ? 'border: 1px solid #FFC107 !important;' : 'border: 1px solid #DC3545 !important;'" class="text-center py-1" style="border-radius: 6px;"> -->
                            {{ value }}
                          <!-- </div> -->
                        </div>
          
                        <div v-if="header.format === 'regex'">
                          <span
                            class="two-line">
                            {{ rowFormat(header.format, value) }}
                          </span>
                        </div>
          
                        <div v-if="header.format === 'image'"
                          class="ma-4">
                          <v-avatar
                            size="60"
                            tile
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="POS Amanata" 
                              :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="15"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </div>
  
                        <div v-if="header.format === 'image_potrait'"
                          class="ma-0">
                          <v-img 
                            contain
                            width="30"
                            height="30"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="15"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
  
                        <div v-if="header.format === 'image_landscape'"
                          class="ma-4">
                          <v-img 
                            contain
                            width="200"
                            height="125"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="15"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
  
                        <div v-if="header.format === 'action'">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="reset(index); dialog.form = true;"
                                
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="#3b3f5c"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 8px;">
                                <v-icon size="13">mdi-pencil-outline</v-icon>
                              </v-btn>
                            </template>
  
                            <span>Ubah</span>
                          </v-tooltip>
  
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"
  
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="#e7515a"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 8px;">
                                <v-icon size="13">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip>
  
                          <v-tooltip 
                            right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toReset(item.id)"
  
                                v-bind="attrs"
                                v-on="on"
                                
                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="orange"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 8px;">
                                <v-icon size="13">mdi-lock-reset</v-icon>
                              </v-btn>
                            </template>
  
                            <span>Reset Password</span>
                          </v-tooltip>
  
                          <!-- <v-menu
                            right
                            offset-y
                            style="box-shadow: none !important;">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="24" min-height="24"
                                x-small
                                rounded
                                color="#37474F"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="15">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
  
                            <v-list
                              dense
                              color="#808080"
                              class="py-1 my-2"
                              style="border-radius: 10px !important;">
                              <v-list-item
                                class="px-2">
                                <v-tooltip 
                                  right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="toRole(value)"
  
                                      v-bind="attrs"
                                      v-on="on"
  
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      color="indigo"
                                      elevation="0"
                                      class="white--text text-capitalize px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon small>mdi-account-settings-outline</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Hak Akses</span>
                                </v-tooltip>
                              </v-list-item>
  
                              <v-list-item
                                class="px-2">
                                <v-tooltip 
                                  right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="toReset(value)"
  
                                      v-bind="attrs"
                                      v-on="on"
                                      
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      color="orange"
                                      elevation="0"
                                      class="white--text text-capitalize px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="15">mdi-lock-reset</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Reset Password</span>
                                </v-tooltip>
                              </v-list-item>
                            </v-list>
                          </v-menu> -->
                        </div>
  
                        <div v-if="header.format === 'bool'"
                          class="d-flex align-center justify-center">
                          <!-- <v-switch
                            @change="toStatus(value, index)"
                            v-model="value"
                            color="success"
                            class="ma-auto"
                            hide-details>
                          </v-switch> -->
                        </div>
  
                        <div v-if="header.format === 'status'"
                          class="d-flex justify-center">
                          
                        </div>
                      </div>
                    </template>
  
                    <template v-slot:[`item.index`]="{ index }">
                      {{ lastIndex + index }}
                    </template>
  
                    <v-progress-linear 
                      v-show="process.load" 
                      slot="progress" 
                      color="white" 
                      indeterminate>
                    </v-progress-linear>
                  </v-data-table>
              </div>
            </v-card-text>
          </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
  data() {
    return {
      filter: {
        school_id: '',
        year: new Date().getFullYear(),
        pengguna: 'Siswa',
        gender: 'Laki-laki',
        religion: 'Islam',
        status: 'Hadir'
      },
      school: [],
      series: [{
        name: 'Hadir',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 63, 58, 60]
      }, {
        name: 'Terlambat',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 102, 109, 115]
      }, {
        name: 'Izin',
        data: [35, 41, 36, 26, 45, 48, 52, 53, 41, 36, 26, 45]
      },  {
        name: 'Alpha',
        data: [35, 100, 98, 87, 105, 91, 114, 94, 53, 41, 36, 26]
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 5,
            borderRadiusApplication: 'end'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        colors:['#28A745', '#007BFF', '#FFC107', '#DC3545'],
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yaxis: {
          // title: {
          //   text: '$ (thousands)'
          // }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          // y: {
          //   formatter: function (val) {
          //     return "$ " + val + " thousands"
          //   }
          // }
        }
      },

      pieChart: {
        series: [44, 55],
        chartOptions: {
          chart: {
            width: 350,
            type: 'pie',
          },
          labels: ['Laki-laki', 'Perempuan'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          // options: {
            legend: {
              position: 'bottom'
            // }
          }
        },
      },
      pieChartAgama: {
        series: [20, 10, 30, 10, 50, 100],
        chartOptions: {
          chart: {
            width: 350,
            type: 'pie',
          },
          labels: ['Islam', 'Kristen', 'Katolik', 'Hindu', 'Budha', 'Konghucu'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          legend: {
            position: 'bottom'
          }
        },
      },
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
          format: 'link'
        },
        { text: 'Waktu', value: 'time' },
        { text: 'Kelas', value: 'kelas' },
        { text: 'Pelajaran', value: 'pelajaran' },
        { text: 'Siswa Hadir', value: 'hadir' },
        { text: 'Siswa Tidak Hadir', value: 'tidak_hadir' },
      ],
      list: [
          {
            status: 'Hadir',
            time: '07:00 - 08:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Matematika',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '08:00 - 09:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Fisika',
            hadir: 28,
            tidak_hadir: 2
          },
          {
            status: 'Hadir',
            time: '09:00 - 10:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Kimia',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '10:00 - 11:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Biologi',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '11:00 - 12:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Bahasa Indonesia',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '12:00 - 13:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Bahasa Inggris',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '13:00 - 14:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Pendidikan Agama',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '14:00 - 15:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Pendidikan Kewarganegaraan',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Hadir',
            time: '15:00 - 16:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Pendidikan Jasmani',
            hadir: 30,
            tidak_hadir: 0
          },
          {
            status: 'Terlambat',
            time: '16:00 - 17:00',
            kelas: 'XII IPA 1',
            pelajaran: 'Seni Budaya',
            hadir: 30,
            width: '100%',
            tidak_hadir: 0
          },
        ],
      process: {
        load: false
      },
      selected: {
        row: [],
        freeze: [],
        delete: [],
        reset: [],
        role: []
      },
    };
  },

  computed: {
    rps () {
      return this.$vuetify.breakpoint.name
    },
    user () {
      this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
      return this.$store.state.user
    },
    fcm () {
      return this.$store.state.fcm
    },
    data_menu () {
      let menu = {}
      this.$store.state.menu.map((item, index) => {
        if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
          item.sub_menu.map((sub, index) => {
            if (sub.link === this.$route.path) {
              menu = sub
            }
          })
        }
      })

      return menu
    },
    isDay () {
      let hours = (new Date()).getHours(),
          day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
      return day
    },
    set_color () {
      return this.$store.state.color
    },
    set_color_rgb () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.97)`
    },
    set_color_rgb_up () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
    },
    set_color_rgb_down () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.25)`
    },

    configHeaders () {
      return this.headers.filter(header => !header.hide)  
    },
    years () {
      let max = new Date('10-01-2023').getFullYear()+10, min = max - 10, years = []
      // console.log(new Date('10-01-2024').getFullYear())

      this.filter.year = this.$store.state.year

      for (let i = max; i >= min; i--) {
        years.push({
          text: i,
          value: i
        })
      }

      return years
    }
  },

  mounted() {
    this.fetchSchool()
  },
  methods: {
    async fetchSchool() {

        let params = {
        limit: 10000000000000
      }
      let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'

      await get(`${url}`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.school = res.results.data
        }
      })
    },
  },
};
</script>

<style>
</style>